import './current'
import './mobile'

$(() => {
    let $html = $('html')

    $('[id="menu"] li .dropdown').closest('li').on({
        mouseenter () {
            $html.addClass('-dropdown-visible')
                .trigger('scroll-lock:apply')
        },
        mouseleave () {
            $html.removeClass('-dropdown-visible')
                .trigger('scroll-lock:remove')
        },
    })
})
